export class Staff {
    personId : number = 0;
    sCode : string = "";
    firstName : string = "";
    lastName : string = "";
    email : string = "";
    jobTitle : string = "";
    department : string = "";
    yardiGroupCode : string = "";
    yardiGroupDescription : string = "";
    approver : string = "";
    caseWorker : string = "";
    inspector : string = "";
    inactive : string = "";
}